<template>
    <div class="confirm-panel">
        <img class="console-logo" :src="require('@/assets/logo_buddycom_color.svg')"/>
        <div class="title" v-t="'message.title_check_confirmCode'"></div>
        <div class="description">
            <p v-html="$t('message.desc_sent_confirmCode1', { email: this.emailAddress })"></p>
            <p v-html="$t('message.desc_sent_confirmCode2')"></p>
        </div>
        <div v-if="showCheckCode" :class="{'check-code-sm' : smScreen , 'check-code' : !smScreen}">
            <el-input :class="{'check-number-sm' : smScreen , 'check-number' : !smScreen}" id="number1" ref="number1" type="number" pattern="\d*"
                v-model = "inputCode.number1.value" @input.native="handleInputConfirmCode($event.target.id)"/>
            <el-input :class="{'check-number-sm' : smScreen , 'check-number' : !smScreen}" id="number2" ref="number2" type="number" pattern="\d*"
                v-model = "inputCode.number2.value" @input.native="handleInputConfirmCode($event.target.id)"/>
            <el-input :class="{'check-number-sm' : smScreen , 'check-number' : !smScreen}" id="number3" ref="number3" type="number" pattern="\d*"
                v-model = "inputCode.number3.value" @input.native="handleInputConfirmCode($event.target.id)"/>
            <el-input :class="{'check-number-sm' : smScreen , 'check-number' : !smScreen}" id="number4" ref="number4" type="number" pattern="\d*"
                v-model = "inputCode.number4.value" @input.native="handleInputConfirmCode($event.target.id)"/>
            <el-input :class="{'check-number-sm' : smScreen , 'check-number' : !smScreen}" id="number5" ref="number5" type="number" pattern="\d*"
                v-model = "inputCode.number5.value" @input.native="handleInputConfirmCode($event.target.id)"/>
            <el-input :class="{'check-number-sm' : smScreen , 'check-number' : !smScreen}" id="number6" ref="number6" type="number" pattern="\d*"
                v-model = "inputCode.number6.value" @input.native="handleInputConfirmCode($event.target.id)"/>
        </div>
        <div class="confirm-message">
            <el-collapse-transition>
                <div v-if="confirmCodeError != null">
                    <div class="confirm-error">{{ confirmCodeError }}</div>
                </div>
            <el-collapse-transition>
        </div>
        <div class="form-button-field">
            <el-button class="default-button" v-on:click="clearConfirmCode" v-t="'message.button_reset'"></el-button>
        </div>
        <div class="confirm-message">
            <div class="description">
                <p v-html="$t('message.desc_check_confirmCode1')"></p>
                <p v-html="$t('message.desc_check_confirmCode2')"></p>
            </div>
        </div>
</template>
<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import partnerServer from "./PartnerServerApi.js";
import characterCheck from './charactercheck.js';
import commonUtil from './commonutil.js';

export default {
    data() {
        return {
            showCheckCode: true,
            confirmCodeError: null,
            msScreen: false,
            inputCode:{
                number1: { value: "",  nextId: "number2" },
                number2: { value: "",  nextId: "number3" },
                number3: { value: "",  nextId: "number4" },
                number4: { value: "",  nextId: "number5" },
                number5: { value: "",  nextId: "number6" },
                number6: { value: "",  nextId: "" },
            }
        };
    },
    created: function() {
        if (commonUtil.isSmartPhoneScreen()) {
            this.smScreen = true;
        }
    },
    methods: {
        checkConfirmCode(confirmCode) {
            let self = this;

            if (this.partner == null) {
                server.postNoError('/checkemailconfirmationcode', {
                    email: this.emailAddress,
                    confirmCode: confirmCode
                })
                .then((res) => {
                    switch(res.data.status) {
                        case 0:
                            self.$emit('check-successful');
                            break;
                        case  -2:
                            self.confirmCodeError = commonUtil.getMessageText(self.$i18n,"error_invalid_confirmCode");
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","checkemailconfirmationcode").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "checkConfirmCode", error);
                });
            } else {
                partnerServer.postNoError('/checkemailconfirmationcode', {
                    email: this.emailAddress,
                    confirmCode: confirmCode
                })
                .then((res) => {
                    switch(res.data.status) {
                        case 0:
                            self.$emit('check-successful');
                            break;
                        case  -2:
                            self.confirmCodeError = commonUtil.getMessageText(self.$i18n,"error_invalid_confirmCode");
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","checkemailconfirmationcode").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "checkConfirmCode", error);
                });
            }
        },
        handleInputConfirmCode(eventTargetId) {
            if (!characterCheck.isValidForNumeric(this.inputCode[eventTargetId].value)) {
                this.inputCode[eventTargetId].value = "";
                this.confirmCodeError = commonUtil.getMessageText(this.$i18n,"error_confirmCode");
                return;
            }
            this.confirmCodeError = null;
            let confirmCode="";
            for (let numberId in this.inputCode) {
                let nextId = this.inputCode[numberId].nextId;
                if (numberId != "number6") {
                    if (numberId == eventTargetId) {
                        if (this.inputCode[nextId].value == "") {
                            this.$refs[nextId].focus();
                        }
                    }
                }
                if (this.inputCode[numberId].value != "") {
                    confirmCode += this.inputCode[numberId].value;
                }
            }
            if (confirmCode.length == 6) {
                this.checkConfirmCode(confirmCode);
            }
        },
        clearConfirmCode() {
            this.confirmCodeError = null;
            for (let numberId in this.inputCode) {
                this.inputCode[numberId].value = "";
            }
            this.$refs.number1.focus();
        },
    },
    props: [ 'emailAddress' , 'partner' ]
}
</script>

<style>

</style>

<style scoped>

.confirm-panel {
    text-align: center;
    padding-bottom: 20px;
    background-color: #ecf1fa;
}

.title {
    padding-top: 10px;
}

.description {
    padding-top: 10px;
    padding-bottom: 10px;
}

.confirm-message {
    padding-top: 50px;
}
.confirm-error {
    padding-bottom: 15px;
    height: 35px;
    color: #d55169;
}
.check-number {
    width: 45px;
    padding-left: 15px;
    font-size: 20px;
}
.check-number-sm {
    width: 40px;
    padding-left: 4px;
    font-size: 20px;
}

.check-code >>> .el-input__inner {
    padding-left: 15px;
}
.check-code-sm >>> .el-input__inner {
    padding-left: 14px;
    padding-right: 0px;
}

.console-logo {
    padding-top: 10px;
    padding-bottom: 10px;
    height: 36px;
}

</style>

